import './string.extensions';
import { UrlParam } from './UrlParam';

export class ParamUtils {

    // tslint:disable-next-line:ban-types
    static getUrlWithParams(url: string, params: any): string {
        const paramsArray: UrlParam[] = this.convertParamsDictionaryToArray(params);

        if (!url) {
            return '';
        }

        if (!paramsArray || paramsArray.length === 0) {
            return url.toString();
        }

        let paramsUrl: string = '';
        if (!url.contains('?')) {
            paramsUrl += '?';
        } else {
            paramsUrl += '&';
        }
        paramsUrl += paramsArray[0].key + '=' + paramsArray[0].value;

        for (let i = 1; i < paramsArray.length; i++) {
            const urlParam = paramsArray[i];

            if (!url.contains(urlParam.key)) {
                paramsUrl += '&' + urlParam.key + '=' + urlParam.value;
            }
        }

        return url + paramsUrl;
    }

    static convertParamsDictionaryToArray(params: any): UrlParam[] {
        const paramsArray: UrlParam[] = [];

        for (const key of Object.keys(params)) {
            paramsArray.push(new UrlParam(key, params[key]));
        }

        return paramsArray;
    }

}
